import React, { useState } from 'react';
import { MapPin, Mail, Phone, Clock, Send, CheckCircle } from 'lucide-react';
import '../../Style/Pages/contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    program: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically handle the form submission
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({ name: '', email: '', phone: '', message: '', program: '' });
    }, 3000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <h2 className="contact-title">
            Let's Talk Math!
          </h2>
          <p className="contact-description">
            Ready to start your child's mathematical journey? Get in touch with us today for a free consultation and demo class.
          </p>
        </div>

        <div className="contact-grid">
          {/* Contact Information */}
          <div className="contact-info">
            <div>
              <h3 className="contact-info-title">Get in Touch</h3>
              <div className="contact-info-list">
                <div className="contact-info-item">
                  <div className="contact-info-icon bg-primary-100">
                    <MapPin className="h-6 w-6 text-primary-600" />
                  </div>
                  <div className="contact-info-content">
                    <h4>Visit Us</h4>
                    <p>
                      NO21, Sri Lakshmi Narayani Nagar<br />
                      Sripuram, Vellore 632055
                    </p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-info-icon bg-secondary-100">
                    <Phone className="h-6 w-6 text-secondary-600" />
                  </div>
                  <div className="contact-info-content">
                    <h4>Call Us</h4>
                    <p>+91 9940815691</p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-info-icon bg-accent-100">
                    <Mail className="h-6 w-6 text-accent-600" />
                  </div>
                  <div className="contact-info-content">
                    <h4>Email Us</h4>
                    <p>amigoomath@gmail.com</p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-info-icon bg-purple-100">
                    <Clock className="h-6 w-6 text-purple-600" />
                  </div>
                  <div className="contact-info-content">
                    <h4>Operating Hours</h4>
                    <p>
                      Monday - Saturday: 9:00 AM - 7:00 PM<br />
                      Sunday: 10:00 AM - 5:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-offer">
              <h4 className="contact-offer-title">🎉 Special Offer!</h4>
              <p className="contact-offer-text">
                Book a free trial class today and get 20% off your first month enrollment!
              </p>
              <button className="contact-offer-button">
                Book Free Trial
              </button>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form">
            {isSubmitted ? (
              <div className="success-message">
                <CheckCircle className="success-icon" />
                <h3 className="success-title">Thank You!</h3>
                <p className="success-text">
                  We've received your message and will get back to you within 24 hours.
                </p>
              </div>
            ) : (
              <>
                <h3 className="contact-form-title">Send us a Message</h3>
                <form  className="form-group">
                  <div className="form-field">
                    <label htmlFor="name" className="form-label">
                      Parent/Guardian Name *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      value={formData.name}
                    //   onChange={handleChange}
                      className="form-input"
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="email" className="form-label">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                    //   onChange={handleChange}
                      className="form-input"
                      placeholder="Enter your email"
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="phone" className="form-label">
                      Phone Number *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      required
                      value={formData.phone}
                    //   onChange={handleChange}
                      className="form-input"
                      placeholder="Enter your phone number"
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="program" className="form-label">
                      Program Interest
                    </label>
                    <select
                      id="program"
                      name="program"
                      value={formData.program}
                    //   onChange={handleChange}
                      className="form-select"
                    >
                      <option value="">Select a program</option>
                      <option value="kiddy">KIDDY (Ages 5-8)</option>
                      <option value="buddy">BUDDY (Ages 9-15)</option>
                      <option value="both">Both Programs</option>
                    </select>
                  </div>

                  <div className="form-field">
                    <label htmlFor="message" className="form-label">
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      value={formData.message}
                    //   onChange={handleChange}
                      className="form-textarea"
                      placeholder="Tell us about your child's age, current math level, or any questions you have..."
                    />
                  </div>

                  <button
                    type="submit"
                    className="form-submit"
                  >
                    <Send className="h-5 w-5" />
                    <span>Send Message</span>
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;